// extracted by extract-css-chunks-webpack-plugin
module.exports = {"facet":"Fxmp81N6atGMZgRSWIQm","title":"pprzFJSQsVyDpTTfKeKU","titleFontWeight":"YORUHRxzibhlDpbNmyBS","expander":"Xs31ar_j6UVyNO4_QyEe","panel":"lN8PVKeSk5Xjkc15H7bx"};